import 'html/include/js/om/om';
import 'html/include/js/zepto.min';
import 'html/include/js/jquery.unveil';
import 'html/include/js/zepto-anim.min';
import '@html/_common/script_es6';

import {
  byUserInteraction,
  libInit,
  parameters,
} from '@html/_common/utils';
import EmailAquisitionPopUp from '@app/_common/scout/components/email-aquisition-popup/email-aquisition-popup';
import LiveChat from '@html/_modules/live-chat';
import AOEmbed from '@app/clp/embed';
import AOClpStickyMenu from './sticky_menu';

const sliders = [];

export default function ContentLandingPage() {
  this.initiate = () => {
    this.initiateIFrameLogic();
    byUserInteraction('initiate-clp-tooltips', this.initiateTooltipsIfPresentOnPage);

    byUserInteraction('initiate-clp-email-popup', () => {
      const emailAquisitionPopUp = new EmailAquisitionPopUp();
      emailAquisitionPopUp.initiate();
    });

    const modulesCount = window.clpModules?.length;

    for (let i = 0; i < modulesCount; i += 1) {
      window.clpModules[i].initiate();
    }

    $('.live-chat').click(() => new LiveChat());

    Object.values(parameters?.blocks || []).forEach((block) => {
      if (![
        'title',
        'faq',
        'simple_image',
        'social_proof',
        'table',
        'testimonial',
        'text',
        'simple_text',
        'when_to_visit',
        'referral_share',
        'navigation_menu',
        'basics',
        'custom_html',
        'country_information',
        'clp_with_images',
        'divider',
        'image_line',
        'operator_header',
        'operator_guides',
        'operator_about',
        'operator_transports',
        'phone_numbers',
        'custom_tdp_tour_title',
        'custom_tdp_info',
        'custom_tdp_reviews',
        'why_travel_with_us',
      ].includes(block.type)) {
        import(/* webpackChunkName: "clp/blocks/[request]" */`@app/clp/${block.type}/index`).then((module) => {
          const BlockModule = module.default;
          const blockModule = BlockModule(sliders);
          blockModule.initiate();
        });
      }
    });

    if ($('.js-ao-sticky-menu').length > 0) {
      const stickyMenu = AOClpStickyMenu();
      stickyMenu.initiate();
    }
  };

  this.initiateTooltipsIfPresentOnPage = () => {
    const tooltipsArePresent = $('.ttip').length > 0;
    if (tooltipsArePresent) {
      libInit('tooltip');
    }
  };

  this.initiateIFrameLogic = () => {
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
      const embed = AOEmbed();
      embed.initiate();
    }
  };
}
